import React from 'react';

class UnderConstruction extends React.Component {
  render () {
    return (
        <div className="under-construction">
            <div className="under-construction-content">
                <i className="fas fa-cogs fa-2x"></i>
                <span>Under constuction</span>
            </div>
        </div>
      )
  }
}

export default UnderConstruction;